import packageJson from '../package.json';
export const version = packageJson.version || '0.0.0';
